/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";

const secondaryVue = new Vue();
import CompanyService from "@/services/companyService";
import DateService from "@/services/dateService";
import SystemContextService from "@/services/SystemContextService";

import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

import Emitter from "tiny-emitter";
var emitter = new Emitter();
Vue.prototype.$emitter = emitter;

import VueJwtDecode from "vue-jwt-decode";
Vue.use(VueJwtDecode);

import vueDebounce from "vue-debounce";
Vue.use(vueDebounce);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7y");

import VueDndZone from "vue-dnd-zone";
import "vue-dnd-zone/vue-dnd-zone.css";

import VueProgressBar from "vue-progressbar";

Vue.use(VueProgressBar, {
  color: "#007cbe",
  failedColor: "red",
  height: "2px",
  autoFinish: false,
});

import LocalStorageService from "./infastructure/localStorage";
LocalStorageService.provision();

import Components from "./infastructure/components";
Components.provision();

import Axios from "./infastructure/axios";
Axios.provision(emitter, LocalStorageService);

import Filters from "./infastructure/filters";

import Validators from "./infastructure/validators";

import titleMixIn from "./mixins/titleMixin.js";
Vue.mixin(titleMixIn);

Vue.use(require("vue-moment"));

// router setup
import router from "./routes/router";

// plugin setup
Vue.use(DashboardPlugin);

import { hasRole } from "@/services/configService.js";
/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  provide: {
    companyService: new CompanyService(),
    dateService: new DateService(),
    systemContextService: new SystemContextService(),
    hasRole: hasRole
  },
});
